// Vendors
import React from 'react';
import { connectPagination } from 'react-instantsearch-dom';
import classnames from 'classnames';

// Helpers
import { range } from '../../lib/utilities';

const Pagination = ({
  currentRefinement,
  refine,
  nbPages,
  createURL,
  padding = 2,
  className
}) => {
  if (nbPages < 2) return null;

  const hasPrevNext = padding * 2 + 1 < nbPages;
  const isPrevVisible = hasPrevNext && currentRefinement > 1;
  const isNextVisible = hasPrevNext && currentRefinement < nbPages;

  const getPageRange = () => {
    let firstPage = currentRefinement - padding;
    let lastPage = currentRefinement + padding;

    if (lastPage >= nbPages) {
      firstPage = nbPages - padding * 2;
      lastPage = nbPages;
    }

    if (firstPage <= 1) {
      firstPage = 1;
      lastPage = 1 + padding * 2;
    }

    if (nbPages < 1 + padding * 2) {
      firstPage = 1;
      lastPage = nbPages;
    }

    return range(firstPage, lastPage);
  };

  return (
    <ul className={classnames('pagination', className)}>
      {isPrevVisible && (
        <li>
          <a
            href="#"
            aria-label="Previous"
            onClick={(event) => {
              event.preventDefault();
              refine(currentRefinement - 1);
            }}
          >
            <i className="icon perc-icon-chevron-left"></i>
          </a>
        </li>
      )}

      {getPageRange().map((page) => {
        return (
          <li
            key={page}
            className={classnames('pagination__item', {
              'pagination__item--active': currentRefinement === page
            })}
          >
            <a
              href={createURL(page)}
              onClick={(event) => {
                event.preventDefault();
                if (currentRefinement !== page) refine(page);
              }}
            >
              {page}
            </a>
          </li>
        );
      })}

      {isNextVisible && (
        <li>
          <a
            href="#"
            aria-label="Next"
            onClick={(event) => {
              event.preventDefault();
              refine(currentRefinement + 1);
            }}
          >
            <i className="icon perc-icon-chevron-right"></i>
          </a>
        </li>
      )}
    </ul>
  );
};

export default connectPagination(Pagination);
